import React from "react";
import Hero from "../../Components/home/Hero/Hero";
import About from "../../Components/home/About/About";
import Services from "../../Components/home/Services/Services";
import Supply from "../../Components/home/Supply/Supply";
import Contact from "../../Components/home/Contact/Contact";

const Home = () => {
  return (
    <>
      <div>
        <Hero />
        <About />
        <Services />
        <Supply />
        <Contact />
      </div>
    </>
  );
};

export default Home;
